'use client'
import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { faAngleDown, faHouse } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeaderProps } from './Header'

const Navbar = ({ menus = [], adsMenus = [] }: HeaderProps) => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 216)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <nav
        className={`bg-white py-5 border-b border-t border-[E5E5E5] hidden xl:block transition-all duration-300 ${
          isScrolled ? 'fixed top-0 left-0 w-full shadow-md z-50' : ''
        }`}
      >
        <ul className="flex items-center justify-center gap-6">
          {/* Home Icon */}
          <li className="group">
            <Link
              href="/"
              className="flex items-center gap-2 text-[20px] font-medium transition-all group-hover:text-primary"
            >
              <FontAwesomeIcon icon={faHouse} />
              <span className="capitalize text-[16px] font-medium transition-all hover:text-primary">
                Trang chủ
              </span>
            </Link>
          </li>
          {/* Main menu */}
          {menus &&
            menus?.map((item) => (
              <li key={item.id} className="relative group">
                <Link
                  href={`/danh-muc/${item.slug}`}
                  className="flex items-center gap-2 capitalize text-[16px] font-medium transition-all hover:text-primary"
                >
                  <span>{item.name}</span>
                  {Array.isArray(item.childCategories) && item.childCategories.length > 0 && (
                    <FontAwesomeIcon
                      icon={faAngleDown}
                      className="transition-all group-hover:rotate-180"
                    />
                  )}
                </Link>
                {/* Submenu */}
                {Array.isArray(item.childCategories) && item.childCategories.length > 0 && (
                  <ul className="absolute opacity-0 invisible translate-y-3 transition-all group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 top-full left-0 p-2 min-w-[150%] xl:w-[200px] shadow bg-white border border-gray-200 z-50">
                    {item.childCategories.map((subitem) => (
                      <li key={subitem.id} className="group relative mb-2">
                        <Link
                          href={`/danh-muc/${item.slug}/${subitem.slug}`}
                          className="flex items-center gap-2 capitalize text-[15px] font-medium transition-all hover:text-primary"
                        >
                          {subitem.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          <li className="group">
            <Link
              href="https://www.youtube.com/@TAPNewsUS/videos"
              className="flex items-center gap-2 text-[20px] font-medium transition-all group-hover:text-primary"
            >
              <span className="capitalize text-[16px] font-medium transition-all hover:text-primary">
                Video
              </span>
            </Link>
          </li>
          <li className="relative group">
            <Link
              href="https://raovat.iamtapnews.com/"
              target="_blank"
              className="flex items-center gap-2 capitalize text-[16px] font-medium transition-all hover:text-primary"
            >
              <span>Rao Vặt</span>
              <FontAwesomeIcon
                icon={faAngleDown}
                className="transition-all group-hover:rotate-180"
              />
            </Link>
            {/* Submenu */}
            {Array.isArray(adsMenus) && adsMenus.length > 0 && (
              <ul className="absolute opacity-0 invisible translate-y-3 transition-all group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 top-full left-0 p-2 min-w-[150%] xl:w-[200px] shadow bg-white border border-gray-200 z-50">
                {adsMenus.map((subitem) => (
                  <li key={subitem.slug} className="group relative mb-2">
                    <Link
                      href={`https://raovat.iamtapnews.com/danh-muc/${subitem.slug}`}
                      className="flex items-center gap-2 capitalize text-[15px] font-medium transition-all hover:text-primary"
                    >
                      {subitem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        </ul>
      </nav>
    </>
  )
}

export default Navbar
